import type { FeedbackMessages } from './en';

const fi: FeedbackMessages = {
  qualified: {
    title: 'Kiitos, että osallistuit tähän tutkimukseen!',
    text: 'Voit nyt sulkea selainikkunan.\n\nToivomme näkevämme sinut pian uudelleen.',
  },
  quotaFull: {
    title: 'Tämä tutkimus on suljettu',
    text: 'Kiitos kiinnostuksestasi tutkimustamme kohtaan.\n\nOlemme valitettavasti saaneet kaikki tarvitsemamme vastaukset.\n\nToivomme näkevämme sinut jossakin tulevassa tutkimuksessamme!',
  },
  terminated: {
    title: 'Kiitos palautteestasi!',
    text: 'Toivomme näkevämme sinut pian tulevissa tutkimuksissamme. Siihen asti toivotamme sinulle mukavaa päivänjatkoa.\n\nSulje tämä selainikkuna.',
  },
  mismatch: {
    title: 'Kiitos kiinnostuksestasi',
    text: 'Et valitettavasti kuulu tämän tutkimuksen kohderyhmään.\n\nVoit sulkea tämän sivun.',
  },
  error: {
    title: 'Emme voi käsitellä pyyntöäsi',
    linkProblemDetailed:
      'Seuraamassasi linkissä on ongelmia. Tarkista, että osoiterivin linkki vastaa sinulle annettua linkkiä, ja yritä uudelleen.',
    linkProblemGeneric:
      'Seuraamassasi linkissä on ongelmia. Yritä ystävällisesti uudelleen.',
    contactPerson:
      'Jos ongelma jatkuu, ilmoita asiasta henkilölle, jolta sait linkin.',
  },
};

export default fi;
